import React, { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
    selected: boolean;
    onClick: (x: React.MouseEvent<HTMLButtonElement>) => void;
}

export function SelectedButton({
    selected,
    onClick,
    children
}: Props): JSX.Element {
    return (
        <button
            onClick={(x) => onClick(x)}
            className={`flex w-full px-[20px] py-[12px] gap-8 text-sm items-center hover:bg-secondary-blue-subtle rounded text-primary-identity-Blue ${
                selected
                    ? "bg-secondary-blue-lightest font-semibold"
                    : "font-normal"
            }`}
        >
            {children}
        </button>
    );
}
